// src/components/WhatsAppButton.tsx
"use client";

const WhatsAppButton = () => {
  const phoneNumber = process.env.NEXT_PUBLIC_PHONE_NUMBER;

  if (!phoneNumber) {
    console.error("Número de telefone do WhatsApp não definido.");
    return null;
  }

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "25px",
        right: "25px",
        zIndex: 99999,
      }}
    >
      <img
        src="https://host2b.net/download/imagem/whatsapp-icon.png"
        alt="WhatsApp"
        style={{ height: "80px" }}
      />
    </a>
  );
};

export default WhatsAppButton;
